import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getAll(accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: accountID ? `/trucks?accountID=${accountID}` : '/trucks'
      }))
  );
}

async function getById(truckID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/trucks/${truckID}`
      }))
  );
}

async function create(truck) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/trucks',
        body: JSON.stringify(truck)
      }))
  );
}

async function createMultiple(trucks) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/trucks/bulk',
        body: JSON.stringify(trucks)
      }))
  );
}

async function update(truck) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/trucks/${truck.truckID}`,
        body: JSON.stringify(truck)
      }))
  );
}

// prefixed function name with underscore because delete is a reserved word in javascript
async function Delete(truckID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/trucks/${truckID}`
      }))
  );
}

const truckService = {
  create,
  createMultiple,
  getAll,
  getById,
  update,
  delete: Delete
};

export default truckService;
